module.exports = __webpack_public_path__ + "img/collaborate_13.ae99f4fd.jpg";